import { Box, Typography } from "@mui/material";
import { AccordionStyled } from "./accordion";
import { TEXT } from "../../../constants/text";
import { formatArea } from "../../../utils/formatting";
import { TooltipWithIconCustom } from "../../ui/tooltip-custom";

// style
import "./property-data.css";


export const PropertySection = ({ propertyData, displayTitle = true }) => {
  const kpis = [
    {
      id: "area",
      name: TEXT.sidebarResults.site.siteAreaTitle,
      unit: formatArea(propertyData?.area)?.unit,
      value: formatArea(propertyData?.area)?.value,
      tooltip: TEXT.sidebarResults.site.siteAreaTooltip,
    },
    {
      id: "perimeter",
      name: TEXT.sidebarResults.site.perimeterTitle,
      unit: "m",
      valueKey: propertyData?.perimeter,
      tooltip: TEXT.sidebarResults.site.perimeterTooltip,
    },
    {
      id: "borderOffset",
      name: TEXT.sidebarResults.site.borderTitle,
      unit: "m",
      value: propertyData?.minBorderDistance,
      tooltip: TEXT.sidebarResults.site.borderTooltip,
    },
    {
      id: "maxBuildingHeight",
      name: TEXT.sidebarResults.site.heightTitle,
      unit: "m",
      value: propertyData?.maxConstrHeight,
      tooltip: TEXT.sidebarResults.site.heightTooltip,
    },
    /* {
      id: "maxBuildingDensity",
      name: "Max. Building Density",
      unit: "%",
      valueKey: "buildingDensity",
    }, */
  ];
  return (
    <Box
      mb={"16px"}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        width: "100%",
      }}
    >
      {/* <Box
        sx={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <IconMapPin fill="#5D5F6A" width={"18px"} height={"18px"} />

        <Typography fontSize={14} fontWeight={400}>
          {propertyData?.location}
        </Typography>
      </Box> */}
      <AccordionStyled
        title={"Site"}
        expandedDefault={false}
        component="site"
        location={propertyData?.location}
        displayTitle={displayTitle}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            width: "100%",
          }}
        >
          {/* location */}

          {/* property area */}
          {/* <Box
            sx={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <IconPropertyArea fill="#5D5F6A" width={"18px"} height={"18px"} />

            <Typography fontSize={12} fontWeight={400}>
              {propertyData?.area}
            </Typography>
            <Typography fontSize={12} fontWeight={400}>
              m²
            </Typography>
          </Box> */}

          <div className="table-kpis">
            {kpis.map(
              (kpi) =>
                (kpi.value || kpi.value === 0) &&
                kpi.value !== -1 ? (
                  <Box className="kpi-row" key={kpi.id}>
                    <TooltipWithIconCustom text={kpi.tooltip}>
                      <Typography fontSize={"12px"}>
                        {kpi.name} <span className="unit">[{kpi.unit}]</span>
                      </Typography>
                    </TooltipWithIconCustom>

                    <Typography fontSize={"14px"} whiteSpace={'nowrap'}>{kpi.value}</Typography>
                  </Box>
                ) : null
            )}
          </div>
        </Box>
      </AccordionStyled>
    </Box>
  );
};
